import { render, staticRenderFns } from "./RegionForm.vue?vue&type=template&id=a62e6bc2"
import script from "./RegionForm.vue?vue&type=script&lang=js"
export * from "./RegionForm.vue?vue&type=script&lang=js"
import style0 from "./RegionForm.vue?vue&type=style&index=0&id=a62e6bc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports